<script>

export default {
  name: 'EskiOdemeGecmisi',
  props:[
    "data"
  ],
  data() {
    return {
        form: {},
        title:'Eski Ödeme Geçmişi',
        submitted: false,
        tahsilatData: {},
        isLoading: false,
        rows: [],
        alacak:0,
        borc:0,
        tahsilat:0,
        totalData : {},
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
        },
        selectOptions: {
            enabled: false,
            selectOnCheckboxOnly: false,
            selectionInfoClass: 'custom-class',
            selectionText: 'adet kayıt seçildi',
            clearSelectionText: 'seçimi iptal et',
            disableSelectInfo: false,
            selectAllByGroup: false,
        },
        columns: [
        {
          label: 'İşlem Tarihi',
          field: "islemtarihi",
          sortable:false,
        },
        {
          label: 'Banka',
          field: "banka",
          sortable:false,
        },
        
        {
          label: 'Pos',
          field: "bankafirma",
          sortable:false,
        },
        
        {
          label: 'Çek NO',
          field: "cekno",
          sortable:false,
        },
        {
          label: 'Açıklama',
          field: 'aciklama',
          sortable:false,
        },
        {
          label: 'Satış',
          field: 'alacak',
          sortable:false,
        },
        {
          label: 'Komisyon',
          field: 'borc',
          sortable:false,
        },
        {
          label: 'Tahsilat',
          field: 'tahsilat',
          sortable:false,
        },
        {
          label: 'Bakiye',
          field: 'balance',
          sortable:false,
        }
      ]
    }
  },
  watch:{
    data(props){
        this.rows = []
        this.totalData = {}
        this.form = props
        this.updateParams({ columnFilters : props})
        this.loadItems()
    }
  },
  methods: {
    transaction_date(props){
        return this.formatDate(props.transaction_date,"DD.MM.YYYY HH:MM")
    },
    updateParams(newProps) {
        this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
        this.updateParams({ page: params.currentPage })
        this.loadItems()
    },
    onPerPageChange(params) {
        this.updateParams({ perPage: params.currentPerPage })
        this.loadItems()
    },
    onSortChange(params) {
        this.updateParams({
            sort: params,
        })
        this.loadItems()
    },
    onColumnFilter(params) {
        this.updateParams(params)
        this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => { 
            this.totalRecords = response.totalRecords
            this.pageLength = response.pageLength
            this.currentPage = response.currentPage
            this.rows = response.rows
            this.alacak = response.alacak
            this.borc = response.borc
            this.tahsilat = response.tahsilat
        })
    },
    getFromServer() {
        return new Promise((resolve, reject) => {
            this.$http.post(`dealers/${this.form.id}/balances/eski`, this.serverParams)
            .then(res => {
                resolve({
                    rows: res.data.odemeler.data,
                    totalRecords: res.data.odemeler.total,
                    pageLength: res.data.odemeler.last_page,
                    currentPage: res.data.odemeler.current_page,
                    alacak: res.data.alacak,
                    borc: res.data.borc,
                    tahsilat: res.data.tahsilat,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    onSearch(params) {
       this.updateParams(params)
       this.loadItems()
    },

    close(){
      this.$parent.$bvModal.hide('odeme_gecmisi')
    },

  },
};
</script>

<template>
  <b-modal id="eski_odeme_gecmisi" size="xl" :title="title"  no-close-on-backdrop hide-footer>
    <div class="row">
        <div class="col-md-12">
            <div class="text-end px-2 py-2 bg-warning text-light">
                Satış Toplam: {{  this.alacak }} |   Komisyon Toplam: {{  this.borc }} |   Tahsilat Toplam: {{  this.tahsilat }}  |   Bakiye Toplam: {{  (this.alacak - this.borc) - this.tahsilat }} 
            </div>
        </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions-bottom">
                    <div class="text-end px-2 py-2 bg-warning text-light">
                        Satış Toplam: {{  this.alacak }} |   Komisyon Toplam: {{  this.borc }} |   Tahsilat Toplam: {{  this.tahsilat }}  |   Bakiye Toplam: {{  (this.alacak - this.borc) - this.tahsilat }} 
                    </div>
                </div>
            </vue-good-table>
        </div>
      </div>
    </div>
</b-modal>
</template>